if (!customElements.get('tharw-gallery-progress')) {
  customElements.define(
    'tharw-gallery-progress',
    class TharwGalleryProgress extends HTMLElement {
      connectedCallback() {
        this.bar = this.querySelector('.tharw-gallery-progress__bar');
        this.slider = this.closest('slider-component')?.querySelector('.slider');
        if (!this.bar || !this.slider) return;
        this.update = this.update.bind(this);
        this.slider.addEventListener('scroll', this.update, { passive: true });
        window.addEventListener('resize', this.update);
        this.update();
      }

      disconnectedCallback() {
        if (!this.slider) return;
        this.slider.removeEventListener('scroll', this.update);
        window.removeEventListener('resize', this.update);
      }

      update() {
        const visibleRatio = this.slider.clientWidth / this.slider.scrollWidth;
        const barWidth = Math.max(visibleRatio * 100, 10);
        const maxScroll = this.slider.scrollWidth - this.slider.clientWidth;
        const progress = maxScroll > 0 ? this.slider.scrollLeft / maxScroll : 0;
        this.bar.style.width = `${barWidth}%`;
        this.bar.style.marginLeft = `${progress * (100 - barWidth)}%`;
      }
    }
  );
}
